import isNumber from 'utilities/isNumber';

import { getAgentNpn } from './getSessionData';

const buildQueryString = parameters => {
    const queryString = new URLSearchParams(parameters).toString();

    return queryString ? `?${queryString}` : '';
};

const buildUrlWithQueryString = ({ parameters, url }) => {
    const filteredParameters = removeEmptyEntries(parameters);
    const queryString = buildQueryString(filteredParameters);

    return `${url}${queryString}`;
};

const maybeMakeFetchAbortable = (options, signal) => {
    if (signal) {
        options.signal = signal;
    }

    return options;
};

const removeEmptyEntries = keyValuePairs =>
    Object.fromEntries(
        Object.entries(keyValuePairs).filter(
            keyValuePair => typeof keyValuePair[1] !== 'undefined'
        )
    );

const getResponse = async ({
    params = {},
    signal,
    url,
    additionalHeaders = {}
}) => {
    const urlWithParams = buildUrlWithQueryString({ parameters: params, url });
    const agentNpn = url.includes('/Enroll/EnrollmentPdf')
        ? '16274828'
        : getAgentNpn();
    const options = maybeMakeFetchAbortable(
        {
            headers: {
                'Content-Type': 'application/json',
                ...(isNumber(agentNpn) && { isPurl: true }),
                ...(agentNpn && { AgentNPN: agentNpn }),
                ...additionalHeaders
            },
            method: 'GET'
        },
        signal
    );

    const response = await fetch(urlWithParams, options);

    return response;
};

export default getResponse;
